import { render } from "./EditarPlaza.vue?vue&type=template&id=c85f6eac"
import script from "./EditarPlaza.vue?vue&type=script&lang=js"
export * from "./EditarPlaza.vue?vue&type=script&lang=js"

import "./EditarPlaza.vue?vue&type=style&index=0&id=c85f6eac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__